module.exports = __webpack_public_path__ + "static/media/293931.1eb707bd.svg";